import loadable from '@loadable/component';

export const MegalandingRootLoadable = loadable(() => import('./MegalandingRoot'), {
  fallback: null,
  ssr: false,
});
